import type { ReactNode } from "react";

export type Card = {
  key: string;

  title: string;

  render: () => ReactNode;
};

export type Stack = { for: string; cards: readonly Card[] };

export function nothingOpen(conversation: string): Stack {
  return { for: conversation, cards: [] };
}

export function opened(stack: Stack, conversation: string, card: Card): Stack {
  if (stack.for === conversation && stack.cards[0]?.key === card.key) return stack;
  return { for: conversation, cards: [card] };
}

export function back(stack: Stack): Stack {
  return { for: stack.for, cards: stack.cards.slice(0, -1) };
}

export function closed(stack: Stack): Stack {
  return nothingOpen(stack.for);
}

export function drawnFor(stack: Stack, conversation: string): readonly Card[] {
  return stack.for === conversation ? stack.cards : [];
}

export function onlyOne(cards: readonly Card[]): Card | null {
  return cards[cards.length - 1] ?? null;
}
